import styled from 'styled-components';

export const BusinessCardMemberStyles = styled.div`
  background-color: ${props =>
    props.backgroundColor || props.theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  border-radius: 0.3rem;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  width: 17.25rem;
  flex: 0 0 auto;
  margin: 0.5rem;
  text-align: center;

  p,
  a {
    font-size: 1.125rem;
    font-weight: 400;
    color: #06292f;
    margin: 0;
    padding: 0;
    margin-top: 0.8rem;
  }

  .icon-btn {
    display: flex;
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  .business-card-member {
    &__headshot {
      width: 9.375rem;
      height: 9.375rem;
      border-radius: 50%;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &__name-and-qr {
      margin-top: 1.5rem;
      display: flex;
      justify-content: center;
      align-items: center;

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p {
        font-size: 1.25rem;
        color: ${props => props.theme.colors.bedtime};
        padding: 0;
        margin: 0;
      }

      button {
        margin-left: 0.5rem;
      }
    }

    &__title {
      flex-grow: 2;
    }

    &__phone {
    }

    &__email {
    }

    &__tools {
      width: 80%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 1.2rem;
    }
  }

  .icon-btn-icon-stroke {
    stroke: ${props => props.theme.colors.claytonBlue};
    transition: stroke 0.2s;
  }

  .icon-text-wrapper {
    height: 3rem;
    display: flex;
    flex-direction: column;
    color: ${props => props.theme.colors.claytonBlue};
    font-family: 'source-sans-pro';
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    align-items: center;
    justify-content: space-between;
    margin: 0;
  }
`;

export default styled.div`
  background-color: ${props => props.backgroundColor};
  padding: 3rem 2rem 6rem;
  margin-top: 3rem;

  * {
    box-sizing: border-box;
  }

  .qr-modal {
    position: fixed;
    padding: 1.6875rem;
    background: #ffffff;
    box-shadow: 3px 3px 12px rgba(0, 0, 0, 0.1);
    z-index: 51;
    border-radius: 8px;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
  }

  .qr-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 50;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .business-cards-team-section {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 3rem;

    &__header {
      font-size: 1.5625rem;
      font-weight: 700;
      width: 100%;
      display: flex;
      justify-content: center;
      color: ${props => props.headerTextColor};
      margin: 0;
    }

    .sms-btn {
      display: none;
      @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        display: flex;
      }
    }

    &__card {
      display: flex;
    }
    .business-card-member {
      flex-grow: 1;
    }
  }
`;
